import React from 'react';
import { styled, useTheme } from '@vw-marketing/us-components';
import { iconMap } from './icon-map';

const StyledIcon = styled.span<{
  $color?: string;
  $ignoreDefaultColor?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 1;
  ${({ $color, $ignoreDefaultColor }) =>
    !$ignoreDefaultColor && `color: ${$color || 'inherit'};`}
  svg {
    display: block;
    font-weight: inherit;
    ${({ $ignoreDefaultColor }) => !$ignoreDefaultColor && `color: inherit;`}
    ${({ $color, $ignoreDefaultColor }) =>
      !$ignoreDefaultColor && `fill: ${$color || 'inherit'};`}
  }
  padding-bottom: 4px;
`;

export interface IconProps {
  name: string;
  variant?: 'small' | 'default';
  color?: string;
  style?: React.CSSProperties | ((theme: any) => React.CSSProperties);
  ignoreDefaultColor?: boolean;
}

export const Icon = ({
  name,
  color,
  ignoreDefaultColor = false,
  style,
  variant = 'default',
  ...props
}: IconProps) => {
  const theme = useTheme();
  const resolvedStyle = style
    ? typeof style === 'function'
      ? style(theme)
      : style
    : {};

  const IconComponent = iconMap[name] || iconMap.default;
  if (!iconMap[name]) {
    console.warn(`Icon "${name}" not found, using default icon`);
  }

  const resolvedColor = color
    ? color
    : resolvedStyle?.color
      ? resolvedStyle.color
      : !ignoreDefaultColor
        ? theme.colors.focus.main
        : undefined;

  return (
    <StyledIcon
      style={resolvedStyle}
      $color={resolvedColor}
      $ignoreDefaultColor={ignoreDefaultColor}
    >
      <IconComponent variant={variant} {...props} />
    </StyledIcon>
  );
};
